import mixpanel from 'mixpanel-browser';
import {
  DigitalDataEvent,
  MetricsTrackerConfigurationType,
} from '../types/types';
import { maskEmail, maskString } from '../helpers';

export default function mixPanelSubscriber(
  digitalDataEvent: DigitalDataEvent,
  config: MetricsTrackerConfigurationType
) {
  const { mixpanelToken, user } = config;
  const { name, data: digitalData } = digitalDataEvent;
  const { actionType, actionFlow, ...data } = digitalData;

  if (!mixpanelToken) {
    return;
  }

  if (!actionType || !actionFlow) {
    return;
  }

  const {
    id: userId,
    isAuthenticated,
    username,
    languageId,
    package: _package,
    email,
  } = user;

  mixpanel.init(mixpanelToken);

  if (isAuthenticated) {
    mixpanel.identify(userId);
    mixpanel.people.set({
      $name: maskString(username),
      $email: maskEmail(email),
      languageId,
      package: _package,
    });
  }

  mixpanel.track(name, {
    actionType,
    actionFlow,
    ...data,
  });
}
